import { Translation } from "@payair/e-com-common-sdk/core/LanguageHandler"

const swedishLanguage: Translation = {
  welcomeToClickToPay: "Välkommen till Click to Pay",
  welcomeBackToClickToPay: "Välkommen tillbaka till Click to Pay",
  fastSecureOnlineCheckout: "Snabb, säker online betalning",
  weAccept: "Vi accepterar",
  getStarted: "Kom igång",
  emailAddress: "E-postadress",
  continue: "Fortsätt",
  verify: "Verifiera",
  consentText:
    "Jag godkänner att dela min information med Click to Pay för att ge mig möjlighet att skriva in mig i Click to Pay för snabbare betalningar.",
  rememberMe: "Kom ihåg mig",
  rememberMeInBrowser: "Kom ihåg mig i den här webbläsaren",
  rememberMeMoreInformation: "Mer information om att komma ihåg den här webbläsaren",
  rememberMeTooltipPrimary:
    "Om du väljer att bli ihågkommen kan du hoppa över verifieringen och få säker åtkomst till dina sparade kort när du betalar med Click to Pay.",
  rememberMeTooltipWarning:
    "Rekommenderas inte på offentliga eller delade enheter eftersom cookies används.",
  notYou: "Inte du?",
  clickToPay: "Click to Pay",
  existingAccount: "Det ser ut som att du redan har en Click to Pay profil",
  otpInformation: "Vänligen ange den kod som har skickats till: ",
  otpTooShortCode: "Ange giltig kod (6 siffror)",
  resend: "Återsänd",
  changeChannel: "Fortsätt på ett annat sätt",
  selectCard: "Välj ett kort att betala med",
  addCard: "Lägg till nytt kort",
  expired: "Utgånget",
  addToCTP: "Lägg till i Click to Pay",
  selectCardButton: "Välj ett kort",
  changeOTPChannel: {
    subtitle: "Fortsätt med en annan metod",
    option1: "SMSa en annan kod till",
    option2: "E-posta en annan kod till",
    option3: "Betala på ett annat sätt",
  },
  cardSwitchUser: "Få tillgång till dina sparade kort genom att",
  signIn: "logga in",
  addNewCard: "Lägg till ett nytt kort",
  uncheckedConstentWarning:
    "Det här fältet är obligatoriskt. Om du inte samtycker så stäng fönstret och fortsätt med ett annat betalsätt.",
  processing: "Bearbetar",
  createAccount: "Skapa ett nytt konto",
  countryRegion: "Land",
  enterOrSelect: "Ange eller välj",
  storeCard: "Spara kort",
  storeCardDescription: "Vi behöver lite mer information för att spara ditt kort.",
  storeAndPay: "Spara och betala",
  goBack: "Gå tillbaka",
  storeCardLegalBeforeTerms: "Genom att fortsätta godkänner du {network}s ",
  storeCardLegalBetweenLinks: " och förstår att dina uppgifter behandlas enligt ",
  storeCardLegalAfterPrivacy: ".",
  reviewYourDetails: "Granska dina uppgifter...",
  captionVerification:
    "Din e-postadress eller ditt mobilnummer används för att verifiera dig. Kostnader för meddelanden/data kan tillkomma.",
  terms: "Villkor",
  privacyNotice: "Integritetsmeddelande",
  opensInNewWindow: "Öppnas i ett nytt fönster",
  wrongFormat: "Felaktigt format",
  nameWrongFormat: "Använd endast bokstäver, blanksteg, apostrofer eller bindestreck",
  requiredField: "Det här fältet är obligatoriskt",
  allowedLengthRange: "Ange mellan {min} och {max} tecken",
  maximumLength: "Maximal längd är {max} tecken",
  invalidLength: "Ogiltig längd",
  phoneCountryCode: "Telefonens landskod",
  phoneNumber: "Telefonnummer",
  dataDisclosure:
    "Click to Pay kommer att använda denna information för att se om du har några sparade kort. En engångskod kan komma att skickas till denna mobil för att bekräfta att det är du. Kostnader för meddelanden/data kan tillkomma.",
  firstName: "Namn",
  lastName: "Efternamn",
  sms: "SMS",
  email: "E-mail",
  saveCardAndPay: "Spara kort och Betala",
  unexpectedError: "Något gick fel. Försök igen.",
}

export default swedishLanguage
